import {action, computed, observable, runInAction} from 'mobx';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import {message} from "antd";

const PlayTypes =
    ["标准单式", "标准复式", "胆拖", "生肖乐单式", "生肖乐复式", "直选和值", "组三单式", "组三复式", "组三包号", "组三和值",
        "组六单式", "组六复式", "组六包号", "组六和值", "五星", "三星", "二星", "一星", "大小单双", "五星通选",
        "三星和值", "二星和值", "二星组选", "二星组选和值", "前二", "后二", "前一", "后一", "胜平负", "进球数",
        "猜比分", "半全场", "胜负", "让分胜负", "胜分差", "大小分", "前一直选", "任选二", "任选三", "任选四",
        "任选五", "任选六", "任选七", "任选八", "前二直选", "前二组选", "前三直选", "前三组选", "前三", "位置",
        "过二关", "过三关", "大小奇偶", "让球胜平负", "混合过关", "胜负", '三同号', '三不同号', '二同号', '三同号通选',
        '二同号复选', '快三和值', '二不同号', '三连号通选'];

//存储玩法对应的index
const BetTypes = {
    'HH': 54,
    'SPF': 28,
    'RQSPF': 53,
    'JQS': 29,
    'CBF': 30,
    'BQC': 31,
    'SF': 32,
    'RFSF': 33,
    'SFC': 34,
    'DXF': 35
};


/**
 * 单场投注内容
 */
class BetItemData {


    //比赛id
    matchIndex = '';

    matchInfo = '';

    //投注类型
    betType = '';
    betTypeName = '';

    //投注结果
    betResult = '';
    betResultName = '';

    //投注赔率
    betRadio = 0;

    //额外数据,篮球让分胜负和大小分使用
    betSpecial = '';

    //是否中奖
    isWin = false;

    constructor(type) {
        this.betType = type;
        //为了和服务器统一,从PlayTypes读取数据
        this.betTypeName = PlayTypes[BetTypes[type]];
    }

    isLQSpecial() {
        return this.betType == 'RFSF';
    }

    isLQDXFSpecial() {
        return this.betType == 'DXF';
    }

    getOptionString() {
        return `${this.betTypeName}:${this.betResultName}(${this.betRadio})`;
    }

    getKey() {
        return `${this.matchIndex}-${this.getOptionString()}`;
    }

    getDisplay() {
        return `${this.matchInfo}-${this.getOptionString()}`;
    }


    static parserFromString(itemContent, type, radio, special) {

        //混合过关
        if (type === 'HH') {
            //SPF>181122001=3
            //CBF>181122002=2:2
            let tempList = itemContent.split('>');
            return BetItemData.parserType(tempList[0], tempList[1], radio, special);
        } else {
            return BetItemData.parserType(type, itemContent, radio, special);
        }

    }

    static parserType(type, itemContent, radio, special) {
        switch (type) {
            case 'SPF':
                return BetItemData.parserSPF(itemContent, radio);
            case 'RQSPF':
                return BetItemData.parserRQSPF(itemContent, radio);
            case 'JQS':
                return BetItemData.parserJQS(itemContent, radio);
            case 'CBF':
                return BetItemData.parserCBF(itemContent, radio);
            case 'BQC':
                return BetItemData.parserBQC(itemContent, radio);
            case 'SF':
                return BetItemData.parserSF(itemContent, radio);
            case 'RFSF':
                return BetItemData.parserRFSF(itemContent, radio, special);
            case 'SFC':
                return BetItemData.parserSFC(itemContent, radio);
            case 'DXF':
                return BetItemData.parserDXF(itemContent, radio);
            default:
                return undefined;
        }
    }


    static parserSPF(itemContent, radio) {
        let data = new BetItemData('SPF');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betResult = temList[1];

        data.betResultName = BetItemData.getSPFResultName(data.betResult);

        return data;
    }

    static parserRQSPF(itemContent, radio) {
        let data = new BetItemData('RQSPF');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betResult = temList[1];

        data.betResultName = BetItemData.getSPFResultName(data.betResult);

        return data;
    }

    static parserJQS(itemContent, radio) {
        let data = new BetItemData('JQS');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betResult = temList[1];

        data.betResultName = data.betResult;

        return data;
    }

    static parserCBF(itemContent, radio) {
        let data = new BetItemData('CBF');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betResult = temList[1];

        data.betResultName = BetItemData.getCBFResultName(data.betResult);

        return data;
    }


    static parserBQC(itemContent, radio) {
        let data = new BetItemData('BQC');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betResult = temList[1];

        data.betResultName = BetItemData.getBQCResultName(data.betResult);

        return data;
    }

    static parserSF(itemContent, radio) {
        let data = new BetItemData('SF');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betResult = temList[1];

        data.betResultName = BetItemData.getSFResultName(data.betResult);

        return data;
    }

    static parserRFSF(itemContent, radio, special) {
        let data = new BetItemData('RFSF');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betSpecial = special;
        data.betResult = temList[1];

        data.betResultName = BetItemData.getSFResultName(data.betResult);

        return data;
    }

    static parserSFC(itemContent, radio) {
        let data = new BetItemData('SFC');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betResult = temList[1];

        data.betResultName = BetItemData.getSFCResultName(data.betResult);

        return data;
    }

    static parserDXF(itemContent, radio) {
        let data = new BetItemData('DXF');

        let temList = itemContent.split('=');

        data.matchIndex = temList[0];
        data.betRadio = radio;
        data.betResult = temList[1];

        data.betResultName = BetItemData.getDXFResultName(data.betResult);

        return data;
    }

    static getSPFResultName(result) {

        let temps = result.split("/");

        let resultName = '';

        temps.forEach(function (item) {
            if (resultName != '') {
                resultName += '/'
            }

            if (item == '3') {
                resultName += "主胜";
            } else if (item == '1') {
                resultName += "平"
            } else if (item == '0') {
                resultName += "主负"
            }
        });


        return resultName;
    }

    static getSFResultName(result) {

        let temps = result.split("/");

        let resultName = '';

        temps.forEach(function (item) {
            if (resultName != '') {
                resultName += '/'
            }

            if (item == '3') {
                resultName += "主胜";
            } else if (item == '0') {
                resultName += "主负"
            }
        });


        return resultName;
    }

    static getCBFResultName(result) {

        let text = result.replace('9:0', '胜其他');
        text = text.replace('0:9', '负其他');
        text = text.replace('9:9', '平其他');

        return text;
    }

    static getBQCResultName(result) {
        if (result == '') {
            return '';
        }

        let resultTempList = result.split('/');
        let resultList = [];

        for (let i = 0; i < resultTempList.length; i++) {
            let item = resultTempList[i];

            let itemTemps = item.split('-');
            let itemResultList = [];

            itemTemps.forEach(function (data) {
                let itemName = '';
                if (data == '3') {
                    itemName = "胜";
                } else if (data == '1') {
                    itemName = "平"
                } else if (data == '0') {
                    itemName = "负"
                }
                itemResultList.push(itemName)
            });

            resultList.push(itemResultList.join('-'))
        }

        return resultList.join('/');

    }


    static getSFCResultName(result) {

        let temps = result.split("/");

        let resultName = '';

        temps.forEach(function (item) {
            if (resultName != '') {
                resultName += '/'
            }

            switch (item) {
                case '01':
                    resultName += "主胜1-5";
                    break;
                case '02':
                    resultName += "主胜6-10";
                    break;
                case '03':
                    resultName += "主胜11-15";
                    break;
                case '04':
                    resultName += "主胜16-20";
                    break;
                case '05':
                    resultName += "主胜21-25";
                    break;
                case '06':
                    resultName += "主胜26+";
                    break;
                case '11':
                    resultName += "客胜1-5";
                    break;
                case '12':
                    resultName += "客胜6-10";
                    break;
                case '13':
                    resultName += "客胜11-15";
                    break;
                case '14':
                    resultName += "客胜16-20";
                    break;
                case '15':
                    resultName += "客胜21-25";
                    break;
                case '16':
                    resultName += "客胜26+";
                    break;
                default:
            }
        });


        return resultName;
    }

    static getDXFResultName(result) {
        let temps = result.split("/");

        let resultName = '';

        temps.forEach(function (item) {
            if (resultName != '') {
                resultName += '/'
            }
            if (item == '3') {
                resultName += "大分";
            } else if (item == '0') {
                resultName += "小分"
            }
        });

        return resultName;
    }

    chechWin(resultData) {

        // console.log("rey",this)
        // console.log("rey22",resultData)
        switch (this.betType) {
            case 'SPF':
                this.isWin = this.checkItemWin(this.betResult, resultData.spf_result);
                break;
            case 'RQSPF':
                this.isWin = this.checkItemWin(this.betResult, resultData.rqspf_result);
                break;
            case 'JQS':
                this.isWin = this.checkItemWin(this.betResult, resultData.jqs_result);
                break;
            case 'CBF':
                this.isWin = this.checkItemWin(this.betResult, resultData.whole_score);
                break;
            case 'BQC':
                this.isWin = this.checkItemWin(this.betResult, resultData.bqc_result);
                break;
            case 'SF':
                this.isWin = this.checkItemWin(this.betResult, resultData.sf_result);
                break;
            case 'RFSF':
                this.isWin = this.checkItemWin(this.betResult, resultData.rfsf_result_real);
                break;
            case 'SFC':
                this.isWin = this.checkItemWin(this.betResult, resultData.sfc_result);
                break;
            case 'DXF':
                this.isWin = this.checkItemWin(this.betResult, resultData.dxf_result_real);
                break;
            default:

        }
    }

    checkItemWin(betResutl, result) {
        let temps = betResutl.split("/");

        let index = temps.indexOf(result);

        return index != -1
    }

}

/**
 * 投注内容
 */
class BetData {
    //是否为混合过关
    isMix = false;

    //串场次
    chuan = 1;

    //投注场次
    betItemList = [];

    //存放比赛Index方便检索
    matchList = [];

    matchNameMap = {};

    //比赛类型 12:足球 15:篮球
    type = 0;


    //从出票数据中解析投注详情
    //HH|SPF>181122001=3,CBF>181122002=2:2|2*1
    //SPF|181122001=3,181122002=1|2*1
    static parseFromTicket(matchInfoData, ticketData) {

        let data = new BetData();
        let betDatas = ticketData.content.split("|");

        if (betDatas.length != 3) {
            return undefined;
        }


        let radioList = ticketData.ratio.split('|');
        let specialList = ticketData.ticket_special.split('|');
        //投注类型
        let betType = betDatas[0];
        data.type = ticketData.type;

        //HH表示混合过关
        if (betType == 'HH') {
            data.isMix = true;
        }

        //从2*1中解析比赛场次
        data.chuan = Number(betDatas[2].split('*')[0]);

        let matchList = betDatas[1].split(',');

        if (matchList.length !== radioList.length) {
            return undefined;
        }

        //由于只有RFSF和DXF才有,所以需要单独处理索引
        let specialIndex = 0;
        //当没有对应数据时,传''
        if (specialList.length == 0) {
            specialList = [''];
        }


        for (let i = 0; i < matchList.length; i++) {
            let matchData = matchList[i];
            let itemData = BetItemData.parserFromString(matchData, betType, radioList[i], specialList[specialIndex]);


            matchInfoData.forEach(function (item, index) {

                if (item.bout_index == itemData.matchIndex) {

                    if (data.type == 12) {
                        //足球主队在前
                        itemData.matchInfo = `${item.home_team}:${item.awary_team}(${itemData.matchIndex})`;
                    } else {
                        //篮球客队在前
                        itemData.matchInfo = `${item.awary_team}:${item.home_team}(${itemData.matchIndex})`;
                    }
                }

            });

            if (itemData !== undefined) {
                data.betItemList.push(itemData);
                data.matchList.push(itemData.matchIndex);

                if (itemData.isLQSpecial()) {
                    specialIndex++;
                }
            } else {
                console.log("数据解析错误: " + matchData)
            }

        }

        return data;

    }

    //根据比赛index查询投注
    findItem(matchIndex) {
        let itemList = [];
        let itemMatchList = [];

        //没有使用indexOf,是为了防止同一场比赛出现多次
        for (let i = 0; i < this.matchList.length; i++) {
            if (this.matchList[i] == matchIndex) {
                itemList.push(this.betItemList[i]);
                itemMatchList.push(matchIndex);
            }
        }

        return itemList;
    }

    getOptionString() {
        let chuanName = '';
        if (this.chuan == 1) {
            chuanName = '单关';
        } else {
            chuanName = `${this.chuan}串1`;
        }

        let optionStr = `${chuanName}[`;

        this.betItemList.forEach(function (item, index) {
            if (index != 0) {
                optionStr += ',';
            }
            optionStr += item.getDisplay();
        });

        optionStr += ']';
        return optionStr;
    }
}

/**
 * 比赛结果表
 */
class MatchResultData {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        for (let attr in data) {
            this[attr] = data[attr];
        }

    }

    //全场比分
    @observable
    whole_score = '';
    //半场比分
    @observable
    half_score = '';

    //让球数
    @observable
    concede = '';

    //篮球大小分预设总分
    @observable
    dxf_total = '';

    //足球胜平负
    @observable
    spf_result = '';

    @computed
    get spf_result_name() {
        return BetItemData.getSPFResultName(this.spf_result)
    }

    //让球胜平负
    @observable
    rqspf_result = '';

    @computed
    get rqspf_result_name() {
        return BetItemData.getSPFResultName(this.rqspf_result)
    }

    //半全场
    @observable
    bqc_result = '';

    @computed
    get bqc_result_name() {
        return BetItemData.getBQCResultName(this.bqc_result)
    }

    //进球数
    @observable
    jqs_result = '';


    //篮球胜负
    @observable
    sf_result = '';

    @computed
    get sf_result_name() {
        return BetItemData.getSFResultName(this.sf_result)
    }

    //胜分差
    @observable
    sfc_result = '';

    @computed
    get sfc_result_name() {
        return BetItemData.getSFCResultName(this.sfc_result)
    }

    //让分胜负
    @observable
    rfsf_result = '';

    @computed
    get rfsf_result_real() {

        if (this.concede == '') {
            return '';
        }
        let result = '';

        let score = this.whole_score.split(":");
        let home = Number(score[0]);
        let away = Number(score[1]);

        let concode = Number(this.concede);

        if (home + concode > away) {
            result = '3';
        } else {
            result = '0'
        }

        return result
    }

    @computed
    get rfsf_result_name() {

        if (this.concede == '') {
            return '';
        }

        return BetItemData.getSFResultName(this.rfsf_result_real)
    }

    //大小分
    @observable
    dxf_result = '';

    @computed
    get dxf_result_real() {

        if (this.dxf_total == '') {
            return '';
        }

        let result = '';

        let score = this.whole_score.split(":");
        let home = Number(score[0]);
        let away = Number(score[1]);

        let total = Number(this.dxf_total);

        if (home + away > total) {
            result = '3';
        } else {
            result = '0'
        }

        return result
    }

    @computed
    get dxf_result_name() {

        if (this.dxf_total == '') {
            return '';
        }

        return BetItemData.getDXFResultName(this.dxf_result_real)
    }

}

/**
 * 比赛数据
 */
class MatchData {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        if (data == undefined) {
            return
        }
        for (let attr in data) {
            this[attr] = data[attr];
        }

        this.match_result_data = new MatchResultData(data.match_result_data);
    }

    @observable
    id = 0;

    //比赛唯一索引
    @observable
    bout_index = '';

    //赛事名称
    @observable
    match_name = '';
    //主队名称
    @observable
    home_team = '';
    //客队名称
    @observable
    awary_team = '';

    //比赛时间
    @observable
    match_time = '';
    //星期
    @observable
    week = '';

    //让球数
    @observable
    concede = 0;

    //比赛类型 12:足球 15:篮球
    @observable
    type = 0;

    @computed
    get isJCZQ() {
        return this.type === 12;
    }

    @computed
    get isJCLQ() {
        return this.type === 15;
    }

    //全场比分 主:客
    @observable
    whole_score = '';

    //半场比分
    @observable
    half_score = '';

    //半场比分
    @observable
    sp_dxf = '';

    @computed
    get dxf_total() {
        if (this.sp_dxf == '' || this.sp_dxf == null) {
            return ''
        }

        return this.sp_dxf.split(',')[0];

    }

    //比赛结果
    @observable
    match_result_data = new MatchResultData();

    @observable
    betItemList = [];

    //检查是否中奖
    checkWin() {
        if (this.betItemList.length == 0) {
            return
        }

        if (this.match_result_data.whole_score === '') {
            return
        }

        let matchResultData = this.match_result_data;

        this.betItemList.forEach(function (item) {
            item.chechWin(matchResultData);
        })
    }
}

/**
 * 出票数据
 */
class TicketData {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        for (let attr in data) {
            this[attr] = data[attr];
        }
    }

    @observable
    id = 0;

    //北京单场,目前不使用
    @observable
    bet_content = '';
    //投注内容
    @observable
    content = '';
    //结构化投注详情
    @observable
    betData = undefined;

    //注数
    @observable
    count = 0;

    //投注金额
    @observable
    money = '';
    //倍数
    @observable
    multiple = 0;
    //每注金额
    @observable
    one_money = '';
    //中奖金额
    @observable
    win_money = '';

    //出票票号
    @observable
    other_orderid = '';

    //合买分享消息
    @observable
    issue = '';

    //出票状态 未送票, 出票中, 已出票, 出票失败, 已中奖, 未中奖
    @observable
    status = 0;

    @computed
    get status_name() {
        switch (this.status) {
            case 0:
                return '未送票';
            case 1:
                return '出票中';
            case 2:
                return '已出票';
            case 3:
                return '出票失败';
            case 4:
                return '已中奖';
            case 5:
                return '未中奖';
            default:
                return '未知';
        }
    }

    @computed
    get is_win() {
        return this.status_name == '已中奖';
    }

    //出票结果信息
    @observable
    info = '';

    @observable
    ticket_special = '';

    //比赛类型 12:足球 15:篮球
    @observable
    type = 0;
    //玩法投注类型
    @observable
    play_type = '';
    @observable
    play_type_name = '';

}

/**
 * 彩期数据
 */
class TermData {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        for (let attr in data) {
            this[attr] = data[attr];
        }
    }

    @observable
    id = 0;

    //期号
    @observable
    term_no = '';

    //本期开卖时间
    @observable
    start_sale_time = '';
    //本期结束时间
    @observable
    stop_sale_time = '';

}

/**
 * 方案预览数据
 */
class PlanData {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        for (let attr in data) {
            this[attr] = data[attr];
        }
    }

    @observable
    id = 0;

    //创建时间
    @observable
    build_time = '';

    //方案金额
    @observable
    money = '';

    //方案号
    @observable
    number_no = '';

    //每注金额
    @observable
    one_money = '';

    @observable
    type = 0;

}

/**
 * 方案单注数据
 */
class PlanItemData {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        for (let attr in data) {
            this[attr] = data[attr];
        }
    }

    @observable
    id = 0;

    //注数
    @observable
    bet_count = 0;

    //投注内容
    @observable
    content = '';

    //倍数
    @observable
    multiple = 0;
    //每注金额
    @observable
    one_money = '';
    //中奖金额
    @observable
    win_money = '';

    //玩法
    @observable
    play_type = '';

}

class Item {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {

        if (data == undefined) {
            return
        }

        for (let attr in data) {
            this[attr] = data[attr];
        }


        let matchList = [];
        data.match_data.forEach(function (item) {
            matchList.push(new MatchData(item));
        });
        this.match_data = matchList;

        this.plan_data = new PlanData(data.plan_data);
        this.term_data = new TermData(data.term_data);

        let planItemList = [];
        data.plan_item_data.forEach(function (item) {
            planItemList.push(new PlanItemData(item));
        });
        this.plan_item_data = planItemList;

        let ticketList = [];
        let betDataList = [];
        data.ticket_data.forEach(function (item) {
            let ticketData = new TicketData(item);
            ticketList.push(ticketData);

            //计算投注内容
            let betData = BetData.parseFromTicket(matchList, ticketData);

            ticketData.betData = betData;

            if (betData !== undefined) {
                betDataList.push(betData);
            }
        });
        this.ticket_data = ticketList;

        //计算投注倍数
        this.multiple = Number(this.out_amount / this.plan_data.money)


        //处理每场投注内容
        this.match_data.forEach(function (item) {

            let betItemMap = new Map();

            betDataList.forEach(function (betItem) {

                let findList = betItem.findItem(item.bout_index);

                //放入map中,去重复
                findList.forEach(function (findItem) {
                    betItemMap.set(findItem.getKey(), findItem);
                })

            });

            let betItemList = [];
            betItemMap.forEach((values, key) => {
                betItemList.push(values);
            });

            item.betItemList = betItemList;

            if (item.whole_score != '' && item.whole_score != null) {
                if (item.isJCLQ) {

                    item.betItemList.forEach(function (betItem) {

                        if (betItem.isLQSpecial()) {
                            item.match_result_data.concede = betItem.betSpecial;
                        }

                        if (betItem.isLQDXFSpecial()) {
                            item.match_result_data.dxf_total = betItem.betSpecial;
                        }

                    })

                    //当没有投注大小分时,使用场次最后的
                    if (item.match_result_data.dxf_total == '') {
                        item.match_result_data.dxf_total = item.dxf_total
                    }


                }

            }


            item.checkWin()
        });
    }

    @observable
    id;

    //0:待拆票,1:待出票,2:出票中,3:出票成功,4:部分出票成功,5:出票失败,6:"未中奖",7:"已中奖"
    @observable
    status = 0;

    @computed
    get status_name() {
        switch (this.status) {
            case 0:
                return '待拆票';
            case 1:
                return '待出票';
            case 2:
                return '出票中';
            case 3:
                return '出票成功';
            case 4:
                return '部分出票成功';
            case 5:
                return '出票失败';
            case 6:
                return '未中奖';
            case 7:
                return '已中奖';
            default:
                return '未知';
        }
    }

    //0"未开奖", 1"作废", 2"未中奖", 3"已中奖", 4"已兑奖"
    @observable
    order_result = 0;

    @computed
    get order_result_name() {
        switch (this.order_result) {
            case 0:
                return '未开奖';
            case 1:
                return '作废';
            case 2:
                return '未中奖';
            case 3:
                return '已中奖,待派奖';
            case 4:
                return '已中奖,待派奖';
            case 5:
                return '已派奖';
            default:
                return '未知';
        }
    }

    //比赛类型 12:足球 15:篮球
    @observable
    type = 0;

    @computed
    get typeName() {
        if (this.type === 12) {
            return '竞彩足球';
        } else if (this.type === 15) {
            return '竞彩篮球';
        }

        return '未知';
    }

    @computed
    get isJCZQ() {
        return this.type === 12;
    }

    @computed
    get isJCLQ() {
        return this.type === 15;
    }

    //出票商
    @observable
    ticket_third_name = '';

    // //是否合买
    // @observable
    // community_id = 0;

    //投注类型 合买 代购
    @observable
    plan_type = '';

    //投注详情
    @observable
    touzhu_statistics = '';

    //投注类型
    @observable
    touzhu_style = '';

    //中奖金额
    @observable
    win_money = '';

    //出票金额
    @observable
    out_amount = '';

    //优惠金额
    @observable
    coupon_money = '';

    //投注倍数
    @observable
    multiple = 1;

    //投注付款情况 已付款, 部分退款, 退款
    @observable
    pay_status = 0;

    @computed
    get payStatusName() {
        switch (this.pay_status) {
            case 0:
                return '已付款';
            case 1:
                return '部分退款';
            case 2:
                return '退款';
            default:
                return '未知';
        }
    }

    match_data = [];

    plan_data = new PlanData();

    plan_item_data = [];

    term_data = new TermData();

    ticket_data = [];

}

class ItemStore {

    constructor() {
        this.init();
    }

    @action
    init() {
    }


    @observable
    orderDetailData = undefined;


    async getOrderDetail(orderId, successCallback) {

        this.orderDetailData = undefined;

        let url = fetchUrl.admin.orderDetail;
        let res = await service.fetchData({
            path: url,
            params: {
                order_id: orderId
            }
        });
        service.responseHandle({
            res: res,
            success_handle: (res) => {
                runInAction(() => {

                    this.orderDetailData = new Item(res.data);

                    if (successCallback && typeof successCallback === 'function') {
                        successCallback(this.orderDetailData);
                    }

                })
            },
            fail_handle: (res) => {
                message.error(res.error.error_data, 3);
                this.orderDetailData = undefined
            }
        });
        return res;
    }

}

let item_store = new ItemStore();

export {}

export default item_store;



// WEBPACK FOOTER //
// ./src/Store/User/UserList/OrderDetailStore.js